import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/minicity_logo.png';
const _withScopeId = n => (_pushScopeId("data-v-cc7e04ae"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container p-4" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "headerLogo",
        src: _imports_0
    })
], -1));
const _hoisted_3 = {
    key: 1,
    class: "notification bulmaNotification is-danger m-6"
};
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, "There was a problem with your notarization link.", -1));
const _hoisted_5 = { class: "mt-2" };
const _hoisted_6 = {
    key: 2,
    class: "notification bulmaNotification is-warning m-6"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, "This request is not currently ready for notarization.", -1));
const _hoisted_8 = { class: "mt-2" };
const _hoisted_9 = { key: 3 };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Notarization Request", -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", null, "A citizen needs to have their birth record application notarized.", -1));
const _hoisted_12 = { class: "infoBox columns is-align-items-center mt-5" };
const _hoisted_13 = { class: "column" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Citizen Name:", -1));
const _hoisted_15 = { key: 0 };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "HMIS ID:", -1));
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Care Provider:", -1));
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Case Worker:", -1));
const _hoisted_19 = { class: "column" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "View Birth Record Application"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createElementVNode("strong", null, "(including support ID)"),
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-external-link-alt ml-3" })
], -1));
const _hoisted_21 = [
    _hoisted_20
];
const _hoisted_22 = { class: "step" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", { class: "stepNumber" }, "1")
], -1));
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Download Notary Form", -1));
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "pb-2" }, "Use the link below to download the form, ready to be completed and notarized.", -1));
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-download mr-3" }, null, -1));
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "step" }, [
    /*#__PURE__*/ _createElementVNode("div", null, [
        /*#__PURE__*/ _createElementVNode("div", { class: "stepNumber" }, "2")
    ]),
    /*#__PURE__*/ _createElementVNode("div", null, [
        /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Notarize Form"),
        /*#__PURE__*/ _createElementVNode("div", { class: "pb-2" }, "Complete the form, and attach your notary stamp / seal.")
    ])
], -1));
const _hoisted_28 = { class: "step" };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", { class: "stepNumber" }, "3")
], -1));
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Upload Completed Form", -1));
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "pb-2" }, "Use the link below to upload a scan or digital copy of the completed, notarized form.", -1));
const _hoisted_32 = {
    key: 4,
    class: "notification bulmaNotification is-success m-6"
};
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, "Thank you! This request has been successfully notarized.", -1));
const _hoisted_34 = { class: "mt-2" };
import { useAsync } from "@/composables/useAsync";
import { CONFIG } from "@/core/config";
import { onMounted } from "vue";
import { apiExternalNotarization } from "../api";
import { doApiAction } from "@/core/api";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExternalNotarization',
    props: {
        applicationId: {},
        token: {}
    },
    setup(__props) {
        const props = __props;
        const request = useAsync();
        onMounted(() => {
            request.fetch(apiExternalNotarization.getExternalNotarizationRequest("minicity", props.applicationId, props.token));
        });
        const downloadApplicationPDF = () => {
            window.open(apiExternalNotarization.getApplicationPdfViewLink("minicity", props.applicationId, props.token), "_blank");
        };
        const downloadSignedForm = () => {
            window.open(apiExternalNotarization.getSignedFormViewLink("minicity", props.applicationId, props.token), "_blank");
        };
        const uploadNotarizedForm = (uploadInfo) => {
            doApiAction(null, null, "Notarized form PDF uploaded", "Failed to upload notarized form", () => apiExternalNotarization.uploadNotarizedForm("minicity", props.applicationId, props.token, uploadInfo.file)
                .then((doc) => { request.data.status = "RESOLVED"; })
                .finally(() => uploadInfo.onDone()));
        };
        return (_ctx, _cache) => {
            var _a, _b, _c;
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            const _component_DocumentUploadButton = _resolveComponent("DocumentUploadButton");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                (_unref(request).status == 'idle' || _unref(request).status == 'loading')
                    ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                    : (_unref(request).status == 'error')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createTextVNode("Please contact "),
                                _createElementVNode("strong", null, _toDisplayString(_unref(CONFIG).helpEmail), 1),
                                _createTextVNode(" if you require assistance.")
                            ])
                        ]))
                        : (((_a = _unref(request).data) === null || _a === void 0 ? void 0 : _a.status) == 'PENDING')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _hoisted_7,
                                _createElementVNode("div", _hoisted_8, [
                                    _createTextVNode("Please contact "),
                                    _createElementVNode("strong", null, _toDisplayString(_unref(CONFIG).helpEmail), 1),
                                    _createTextVNode(" if you require assistance.")
                                ])
                            ]))
                            : (((_b = _unref(request).data) === null || _b === void 0 ? void 0 : _b.status) == 'OPEN')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _hoisted_10,
                                    _hoisted_11,
                                    _createElementVNode("h3", null, [
                                        _createTextVNode("If you have any questions, please contact "),
                                        _createElementVNode("strong", null, _toDisplayString(_unref(CONFIG).helpEmail), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("p", null, [
                                                _hoisted_14,
                                                _createTextVNode(" " + _toDisplayString(_unref(request).data.citizenName), 1)
                                            ]),
                                            (_unref(request).data.citizenHmisId)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                                                    _hoisted_16,
                                                    _createTextVNode(" " + _toDisplayString(_unref(request).data.citizenHmisId), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("p", null, [
                                                _hoisted_17,
                                                _createTextVNode(" " + _toDisplayString(_unref(request).data.partnerName), 1)
                                            ]),
                                            _createElementVNode("p", null, [
                                                _hoisted_18,
                                                _createTextVNode(" " + _toDisplayString(_unref(request).data.caseworkerName), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("a", {
                                                class: "button is-info p-6",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (downloadApplicationPDF()))
                                            }, _hoisted_21)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                        _hoisted_23,
                                        _createElementVNode("div", null, [
                                            _hoisted_24,
                                            _hoisted_25,
                                            _createElementVNode("a", {
                                                class: "button is-link",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (downloadSignedForm()))
                                            }, [
                                                _hoisted_26,
                                                _createTextVNode(" Download Notary Form ")
                                            ])
                                        ])
                                    ]),
                                    _hoisted_27,
                                    _createElementVNode("div", _hoisted_28, [
                                        _hoisted_29,
                                        _createElementVNode("div", null, [
                                            _hoisted_30,
                                            _hoisted_31,
                                            _createVNode(_component_DocumentUploadButton, {
                                                onUpload: uploadNotarizedForm,
                                                label: "Upload Completed Form"
                                            })
                                        ])
                                    ])
                                ]))
                                : (((_c = _unref(request).data) === null || _c === void 0 ? void 0 : _c.status) == 'RESOLVED')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        _hoisted_33,
                                        _createElementVNode("div", _hoisted_34, [
                                            _createTextVNode("Please contact "),
                                            _createElementVNode("strong", null, _toDisplayString(_unref(CONFIG).helpEmail), 1),
                                            _createTextVNode(" if you require assistance.")
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
            ]));
        };
    }
});
